module.exports = __webpack_public_path__ + "img/noon.7ff0f125.svg";